module.exports = __webpack_public_path__ + "media/images/identicon-48c32733.png";